// Design tokens — ported verbatim from the V0 `protocol.html` (`C` object,
// fonts). Aesthetic: instrument console / Bloomberg terminal redesigned by
// Dieter Rams. Sharp edges, no gradients/shadows, single accent (signal green),
// uppercase mono labels with heavy letter-spacing, serif display for headline
// numbers.

export const C = {
  bg: '#0d0b09',
  panel: '#16130f',
  panel2: '#1d1914',
  line: '#2a241c',
  text: '#ece4d3',
  dim: '#8a7f6c',
  faint: '#5a5346',
  signal: '#c9f364',
  warn: '#e89f3c',
  red: '#e36a5a',
} as const;

export type DesignColor = keyof typeof C;

export const FONT_DISPLAY = "'Fraunces', 'Times New Roman', serif";
export const FONT_MONO = "'JetBrains Mono', ui-monospace, monospace";

// Shared style helpers — small, opinionated bits reused across the shell so we
// don't repeat magic numbers in every component.
export const LABEL_TRACKING = '0.2em';
export const SUBLABEL_TRACKING = '0.15em';
